import React from "react";
import Image from "react-bootstrap/Image";
import { Row, Col, Container } from "react-bootstrap";
import footerLogo from "../../assets/images/dark-logo.png";
import fbook from "../../assets/images/instagram.png";
import lkdin from "../../assets/images/linkedin.png";
import ytube from "../../assets/images/youtube.png";
import SalesforcePartnerBadge from "../../assets/images/Marketing/Comsense-crest.png";
import twitter from "../../assets/images/twitter.png";

const Footer = ({ hideQuickLinks = false, hideSocialMedia = false }) => {
  return (
    <>
      <section
        className="pt-50 bg-darkee footer-area pb-0"
        style={{
          background: "linear-gradient(180deg, #067BB1 -58.37%, #04467A 100%)",
        }}
      >
        <style>{`
          .flag-grid { display:grid; grid-template-columns: repeat(2, minmax(0, 1fr)); gap: 10px 18px; }
          @media (max-width: 576px) { .flag-grid { grid-template-columns: 1fr; } }
          .flag-item { display:flex; gap:10px; align-items:center; }
          .flag-img { width: 40px; height: 26px; border-radius:6px; object-fit:cover; }
          .flag-text { color:#fff; font-size:12px; font-weight:800; letter-spacing:.2px; }
          .flag-phone { color:#e8e8e8; font-size:12px; margin-top:2px; }
        `}</style>
        <Container>
          <Row>
            <Col lg={3} md={6}>
              <Image src={footerLogo} className="fLogo mb-4" />
              {!hideSocialMedia && (
                <div className="footer-wrap">
                  <ul className="d-flex gap-2">
                    {/* <li><a href=''><Image src={wapp}/></a></li> */}
                    <li>
                      <a
                        href="https://www.instagram.com/comsensemktg/#"
                        target="_blank" rel="noreferrer"
                      >
                        <Image src={fbook} />
                      </a>
                    </li>
                    <li>
                      <a
                        href="https://www.linkedin.com/company/comsense-consulting/"
                        target="_blank" rel="noreferrer"
                      >
                        <Image src={lkdin} />
                      </a>
                    </li>
                    <li>
                      <a
                        href="https://www.youtube.com/channel/UCCekynsEDZS7VORzB5KwX9g"
                        target="_blank" rel="noreferrer"
                      >
                        <Image src={ytube} />
                      </a>
                    </li>
                    <li>
                      <a href="https://x.com/ComsenseTech" target="_blank" rel="noreferrer">
                        <Image src={twitter} />
                      </a>
                    </li>
                  </ul>
                </div>
              )}
            </Col>
            {!hideQuickLinks && (
              <Col lg={2} md={6}>
                <div className="footer-wrap">
                  <h5 className="fw-700 ls-0">Quick Links</h5>
                  <ul>
                    <li>
                      <a href="/">Home</a>
                    </li>
                    {/* <li><a href='/'>Resources</a></li> */}
                    <li>
                      <a href="/about">About Us</a>
                    </li>
                    <li>
                      <a href="/contact">Contact Us</a>
                    </li>
                    <li>
                      <a href="/privacy-policy">Privacy policy</a>
                    </li>
                    <li>
                      <a href="/newsletter">Newsletter</a>
                    </li>
                  </ul>
                </div>
              </Col>
            )}
            <Col lg={hideQuickLinks ? 7 : 5} md={6}>
              <div className="footer-wrap">
                <h5 className="fw-700 ls-0">Contact</h5>
                <p>
                  <span className="fw-600 ls-0">Email</span>:
                  connect@comsenseconsulting.com
                </p>
                <div className="flag-grid mt-3">
                  {[
                    { country: "INDIA", code: "in", phone: "+91-917-567-5679" },
                    { country: "UAE", code: "ae", phone: "+971-547-134-455" },
                    { country: "USA", code: "us", phone: "+1-239-383-1618" },
                    {
                      country: "RWANDA",
                      code: "rw",
                      phone: "+250-790-914-908",
                    },
                  ].map((item) => (
                    <div key={item.country} className="flag-item">
                      <img
                        className="flag-img"
                        src={`https://flagcdn.com/w40/${item.code}.png`}
                        alt={`${item.country} flag`}
                        loading="lazy"
                      />
                      <div>
                        <div className="flag-text">{item.country}</div>
                        <div className="flag-phone">{item.phone}</div>
                      </div>
                    </div>
                  ))}
                </div>
              </div>
            </Col>
            <Col lg={2} md={6}>
              <div className="footer-wrap text-start text-lg-end">
                <Image
                  className="footer-salesforce-logo"
                  src={SalesforcePartnerBadge}
                />
              </div>
            </Col>
          </Row>

          <Row className="mt-5 justify-content-center">
            <Col lg={7} md={10}>
              <div className="copyright mt-3">
                <p>
                  Copyright © {new Date().getFullYear()} Comsense Technologies. All rights reserved.
                </p>
              </div>
            </Col>
          </Row>
        </Container>
      </section>
    </>
  );
};

export default Footer;
